﻿import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { UL } from '@blueprintjs/core';
import 'components/listing/Listing.css';

export function BulletedList(
    {
        listItems = [],
        loading = true
    }
) {

    return (
        <div
            className={classNames({ "bp6-skeleton": loading })}
        >
            <UL>
                {
                    listItems.map((item) => {
                        return <li key={item}>{item}</li>
                    })
                }
            </UL>
        </div>
    );

}

BulletedList.propTypes = {
    listItems: PropTypes.array,
    loading: PropTypes.bool,
};